import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import TestGate from "./TestGate";
import "./i18n";
import "./styles/index.css";
import "./styles/master.css";
import { initializeFirebase } from "./firebaseInit"; // 👈 Import the new initializer

// MUI
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { blue } from "@mui/material/colors";

// Run the Firebase Initializer
initializeFirebase(); // 👈 Call it here

// MUI theme
const theme = createTheme({
  palette: {
    primary: { main: blue[800] },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <TestGate>
          <App />
        </TestGate>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
// Force Safari to recognize favicon after React loads
setTimeout(() => {
  const existingIcon = document.querySelector('link[rel="icon"]');
  if (existingIcon) {
    const href = existingIcon.href;
    existingIcon.href = "";
    existingIcon.href = href;
  }
}, 100);
